import {KeyEventsDispatcher, KeyEventProcessor} from '../../../../helpers/KeyEventsDispatcher';

interface Options {
	event_key_options: KeyEventProcessor;
}

export function SetupEventMouse(options: Options) {
	const {event_key_options} = options;

	function on_pointer_move(event: MouseEvent) {
		KeyEventsDispatcher.instance().registerProcessor(event_key_options);
	}

	return {
		on_pointer_move,
	};
}
